import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcMyH18(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    fill: "none",
    viewBox: "0 0 18 18",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.291 5.3a2.291 2.291 0 1 0-4.582 0 2.291 2.291 0 0 0 4.582 0m1.3 0a3.59 3.59 0 1 1-7.182 0 3.59 3.59 0 0 1 7.182 0M14.6 13.344a2.35 2.35 0 0 0-2.35-2.35h-6.5a2.35 2.35 0 0 0-2.35 2.35v1.147c0 .193.157.35.35.35h10.5a.35.35 0 0 0 .35-.35zm1.3 1.147c0 .911-.739 1.65-1.65 1.65H3.75a1.65 1.65 0 0 1-1.65-1.65v-1.147a3.65 3.65 0 0 1 3.65-3.65h6.5a3.65 3.65 0 0 1 3.65 3.65z"
  }));
}
var IcMyH18 = createNolIcon(/*#__PURE__*/forwardRef(SvgIcMyH18));

export { IcMyH18 as I };
